/**
 * Tutor theme — le poste de travail du masteur, en clair (Brand core V16, « Le masteur, sur ses
 * trois écrans »). Le clair est son défaut ; sa nuit est `tutorDark.ts`, au choix dans « Apparence ».
 *
 * Ce que le tuteur porte en propre, par-dessus le socle marine partagé — l'univers teal `#1F7A8C`,
 * « jamais mélangé » aux deux autres (p. 7, 41) :
 *  - son BOUTON : l'aplat teal à relief `#155866`, libellé blanc (4,98:1), et le secondaire blanc au
 *    texte teal (p. 14) — comme l'élève est passé à son orange au portage de son espace ;
 *  - son ÉCRITURE est le teal lui-même : il tient l'AA sur la page (4,60), la carte (4,98) et la
 *    lavande (4,58), donc l'affichage, l'écriture et l'option choisie sont un seul ton — là où
 *    l'élève a besoin de trois oranges ;
 *  - ce qui DÉTRUIT reste le rouge du socle : le teal en est loin en teinte, rien ne s'y confond ;
 *  - les fonds du livre, ceux du parent et de l'élève : la page `#F5F6F8`, les cartes blanches, la
 *    lavande pour les encarts ;
 *  - un statut qui s'écrit prend son encre, comme chez l'élève (le rouge plein ne tient que 4,0 sur
 *    une carte, l'orange d'alerte 2,4) ;
 *  - la lueur d'accueil au teal, pas au jaune (Wajih, 28/10) : une par écran, sur l'accueil
 *    seulement, jamais dans le live.
 *
 * Les titres, le texte et les icônes restent marine : `primary` n'est pas repointé. Le thème n'est
 * posé par aucun écran de l'app tant que l'espace tuteur n'est pas câblé : il ne se voit qu'en
 * Storybook.
 */
import { baseTheme } from "./base"
import { brand } from "./tokens/colors"

export const tutorTheme = {
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
        role: brand.roleTutor,
        "role-strong": brand.roleTutor,
        "role-fill": brand.roleTutor,
        "relief-role": brand.roleTutorShade,
        // Le bouton qui détruit à l'encre du rouge, comme chez l'élève : le blanc sur le rouge plein ne
        // tient que 3,96 (`contrast.test.ts`).
        "danger-fill": brand.errorInk,
        "relief-danger": brand.errorInkShade,
        "text-on-role": brand.white,
        "text-on-secondary": brand.roleTutor,
        "text-link": brand.roleTutor,
        "role-selected": brand.roleTutor,
        surface: brand.page,
        "surface-subtle": brand.lavender,
        "text-success": brand.progressInk,
        "text-warning": brand.alertInk,
        "text-danger": brand.errorInk,
        glow: brand.roleTutor,
    },
} as const
